import { render } from "./Palyamunka.vue?vue&type=template&id=681f435c"
import script from "./Palyamunka.vue?vue&type=script&lang=js"
export * from "./Palyamunka.vue?vue&type=script&lang=js"

import "./Palyamunka.vue?vue&type=style&index=0&id=681f435c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__